import { TODOS } from '~/constants';

export default {
  menu: TODOS,
  data: null,
  failed: false,
};
